import React, {useContext, useEffect, useState} from "react";
import PropTypes from 'prop-types';
import {useDrop} from "react-dnd";
import {AcceptTypes} from "../../ToolBar/ToolBarUtils/ItemTypes";
import RenderComponents from "./RenderByType/RenderComponents";
import {ScreenDesignerContextNew} from "../../../../../../../ContextComponents/ScreenDesignerContextNew";
import {useSelector} from "react-redux";
import {getResponsiveStyles} from "../../utils/lib";


async function generateStyles(styles, appEnv) {
    const {
        boxShadow,
        shadowColor = "#000000",
        border = "",
        borderColor = "#000000",
        flexDirection = "column",
        justifyContent,
        alignItems = 'baseline',
        gap = '0px',
        background,
        backgroundImage,
        padding
    } = styles;
    const backgroundImagePublicUrl = backgroundImage ? process.env.NODE_ENV === 'development' ?
        `${process.env.REACT_APP_REMOTE_HOST}${appEnv}${backgroundImage.url}` :
        `/${appEnv}` + backgroundImage.url : '';
    return {
        wrapperStyles: {
            width: '100%',
            height: '100%',
            boxShadow: `${boxShadow} ${shadowColor}`,
            borderTop: `${border.split(" ")[0] || 0} solid`,
            borderRight: `${border.split(" ")[1] || 0} solid`,
            borderBottom: `${border.split(" ")[2] || 0} solid`,
            borderLeft: `${border.split(" ")[3] || 0} solid`,
            borderColor: borderColor,
            backgroundImage: `url(${backgroundImagePublicUrl})`
        },
        innerBlockStyles: {
            padding,
            background,
            height: '100%',
            overflowY: 'auto',
            flexDirection,
            justifyContent,
            alignItems,
            display: 'flex',
            position: 'relative',
            gap,
        },
    }
}


const BlockComponent = ({component, path, index: parentIndex}) => {
    const {
        onDropComponent, onDropMultipleComponents, onMoveComponent, currentCustomResolution
    } = useContext(ScreenDesignerContextNew);
    const [blockStyles, setBlockStyles] = useState({innerBlockStyles: {}, wrapperStyles: {}})
    const {styles: sourceStyles, children = []} = component;
    const styles = getResponsiveStyles(sourceStyles, currentCustomResolution);
    const hasChildren = children && children.length;
    const {appEnv} = useSelector(state => state.app)
    useEffect(() => {
        async function getStyles() {
            const {wrapperStyles, innerBlockStyles} = await generateStyles(styles, appEnv);
            setBlockStyles({wrapperStyles, innerBlockStyles})
        }
        getStyles()
    }, [styles])


    const [{isOverCurrent}, drop] = useDrop({
        accept: AcceptTypes.column,
        collect: monitor => ({
            isOverCurrent: monitor.isOver({shallow: true}),
        }),
        drop: (item, monitor) => {
            const didDrop = monitor.didDrop();
            let newItem = {...item};
            if (didDrop) {
                return;
            }
            if (item.children && item.type === 'panel') {
                newItem = {
                    ...newItem, children: [{
                        type: 'panel',
                        styles: [{
                            width: "100%",
                            justifyContent: 'flex-start',
                            flexDirection: 'column',
                            alignItems: 'flex-start'
                        }],
                        children: []
                    }]
                };
            }
            if (item.dragType === 'multiple') {
                onDropMultipleComponents(item.component, 0, `${path}.children`);
                return
            }
            if (item.dragType === 'move') {

                //insert panel inside container
                if (item.component.type === 'panel') {
                    item.component = {
                        ...item.component, children: [{
                            type: 'panel',
                            styles: [{
                                width: "100%",
                                justifyContent: 'flex-start',
                                flexDirection: 'column',
                                alignItems: 'flex-start'
                            }],
                            children: item.component.children
                        }]
                    };
                }

                onMoveComponent(item.component, item.from, `${path}.children`, children.length, item.index, parentIndex);
                return
            }

            onDropComponent(newItem, children.length, `${path}.children`)
        }
    });

    return (
        <div style={blockStyles.wrapperStyles} ref={drop}>
            <div style={blockStyles.innerBlockStyles}>
                {hasChildren ? (
                    children.map((item, index) => {
                        return (
                            <RenderComponents
                                key={index}
                                type={item.type}
                                item={item}
                                index={index}
                                path={`${path}.children.${index}`}
                                parentPath={path}
                            />
                        )
                    })
                ) : (
                    isOverCurrent && (
                        <div style={{background: '#009688', height: 10, alignSelf: 'center', width: '100%'}}>

                        </div>
                    )
                )}
            </div>
        </div>
    )
};

BlockComponent.propTypes = {
    component: PropTypes.object,
    path: PropTypes.string,
    index: PropTypes.number
};

export default BlockComponent;